import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export interface ValidationResult {
  [key: string]: boolean;
}

export class CustomValidators {
  constructor() {}

  static dateAfter(
    firstDateControlName: string,
    secondDateControlName: string
  ): ValidatorFn {
    return (controls: AbstractControl): ValidationErrors | null => {
      const firstDateControl = controls.get(firstDateControlName);
      const secondDateControl = controls.get(secondDateControlName);

      if (!firstDateControl || !secondDateControl) return null;

      if (firstDateControl.errors && !firstDateControl.errors['dateAfter']) {
        return null;
      }

      if (!firstDateControl.value || !secondDateControl.value) {
        if (firstDateControl.errors?.['dateAfter']) {
          const { dateAfter, ...remainingErrors } = firstDateControl.errors;
          firstDateControl.setErrors(
            Object.keys(remainingErrors).length ? remainingErrors : null
          );
        }
        return null;
      }

      const firstDate = new Date(firstDateControl.value);
      const secondDate = new Date(secondDateControl.value);
      const bothDatesValid =
        !Number.isNaN(firstDate.getTime()) &&
        !Number.isNaN(secondDate.getTime());

      if (!bothDatesValid) return null;

      if (firstDate <= secondDate) {
        firstDateControl.setErrors({
          ...firstDateControl.errors,
          dateAfter: true,
        });
        return { dateAfter: true };
      }

      if (firstDateControl.errors?.['dateAfter']) {
        const { dateAfter, ...remainingErrors } = firstDateControl.errors;
        firstDateControl.setErrors(
          Object.keys(remainingErrors).length ? remainingErrors : null
        );
      }

      return null;
    };
  }

  static onlyChar(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value == '') return null;

      const re = new RegExp('^[a-zA-Z ]*$');
      if (re.test(control.value)) {
        return null;
      }
      return { onlyChar: true };
    };
  }

  static mustMatch(controlName: string, checkControlName: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get(controlName);
      const checkControl = controls.get(checkControlName);
      if (checkControl?.errors && !checkControl.errors['matching']) {
        return null;
      }

      if (control?.value !== checkControl?.value) {
        controls.get(checkControlName)?.setErrors({ matching: true });
        return { matching: true };
      }
      return null;
    };
  }

  static requiredFileType(type: string) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value == '') return null;
      const file = control.value;
      if (file) {
        const extension = file.split('.')[1].toLowerCase();
        if (type.toLowerCase() !== extension.toLowerCase()) {
          return {
            requiredFileType: true,
          };
        }
        return null;
      }
      return null;
    };
  }

  static strong(control: FormControl): ValidationResult {
    const hasNumber = /\d/.test(control.value);
    const hasUpper = /[A-Z]/.test(control.value);
    const hasLower = /[a-z]/.test(control.value);
    const hasSymbol = /[!@#$%^&*()_+={}\\[\]:;,.<>?/-]/.test(control.value);
    const valid = hasNumber && hasUpper && hasLower && hasSymbol;
    if (!valid) {
      // return what´s not valid
      return { strong: true };
    }
    return {};
  }

  static futureDate(control: FormControl): ValidationErrors | null {
    const today = new Date();

    if (new Date(control.value) < today) return { futureDate: true };

    return null;
  }

  static pastDate(control: FormControl): ValidationErrors | null {
    const today = new Date();

    if (new Date(control.value) >= today) return { pastDate: true };

    return null;
  }
}
